<script>
	import FloatNumber from "./FloatNumber.svelte";
	import Int8 from "./Int8.svelte";
	import Mermaid from "./Mermaid.svelte";
	import Reveal from "reveal.js";
	import { onMount } from "svelte";

	import RevealMarkdown from "reveal.js/plugin/markdown/markdown.js";

	export let rustmod;
	let a = rustmod.Float32.from_str("1e-40");
	let b = rustmod.Float32.from_str("0.1");
	let c = rustmod.Float32.from_str("0.2");
	$: c = a.add(b);

	let i8 = 123;

	onMount(() => {
		Reveal.initialize({
			hash: true,
			controls: false,
			progress: false,
			slideNumber: true,
			width: 1920,
			height: 1080,
			margin: 0.04,
			center: false,
			minScale: 0.5,
			maxScale: 2.0,
			disableLayout: true,
			transitionSpeed: "fast",
			plugins: [RevealMarkdown],
		});
	});
</script>

<div class="reveal">
	<div class="slides">
		<!-- <section>
			<h1 id="num">Numbers as a computer sees them</h1>
			<div id="content">
				<img
					class="pic"
					src="bender-two.jpg"
					alt="0011011011101001200"
				/>
			</div>
		</section>
		<section>
			<Int8 bind:num={i8} />
		</section> -->

		<section>
			<section>
				<FloatNumber name="a" {rustmod} bind:num={a} />
			</section>
			<section>
				<FloatNumber name="b" {rustmod} bind:num={b} />
			</section>
			<section>
				<FloatNumber
					name="a + b"
					{rustmod}
					bind:num={c}
					editable={false}
				/>
			</section>
		</section>
	</div>
	<div class="footer">
		<img class="eelogo" src="ee-logo-white.svg" />
	</div>
</div>

<style lang="scss" global>
	@import "../reveal.js/css/reveal.scss";
	@import "./esprit.scss";
	.footer {
		position: absolute;
		bottom: 0px;
		height: 80px;
		width: 100%;
		color: white;
		background-color: rgb(0, 89, 232);
		text-align: right;
		vertical-align: middle;
	}
	.reveal h1 {
		position: absolute !important;
		top: 50px;
		text-transform: none;
		left: 100px;
		font-size: 52px;
		font-family: Arial;
		font-weight: bold;
		color: rgb(0, 89, 232);
	}
	img.eelogo {
		left: 100px;
	}
	img.pic {
		top: 200px;
	}
	.slides {
		left: 10%;
	}
	.reveal .slides > section div {
		top: 200px !important;
	}
	.content div {
		top: 200px;
	}
	body.reveal-viewport {
		padding: 0;
	}
</style>
